import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TitleChange } from '../services/title-change';
import { Biggen } from "../directives/biggen";
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-phlegon',
  imports: [Biggen, RouterLink],
  templateUrl: './phlegon.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './phlegon.scss',
})
export class Phlegon {
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`Phlegon`);
    this.dynamicTitle.description(`Phlegon of Tralles describes a solar eclipse that occurred during the reign of Tiberius.`);
  }
}
